const xhr = require('client/xhr');
const t = require('engine/i18n/t');
const LANG = require('config').lang;
const pluralize = require('engine/text-utils/pluralize');

t.i18n.add('courses', require('courses/locales/' + LANG + '.yml'));

class FeedbackLoader {
  constructor({elem, filter, activeFilters, loadOnInit}) {
    this.elem = elem;
    this.container = elem.querySelector('[data-feedback-container]');
    if (this.form = elem.querySelector('[data-feedback-form]')) this.initFilter();
    this.baseUrl = `/courses/feedback-fetch`;

    this.filter = this.defaults = filter;
    this.activeFilters = activeFilters || ['stars', 'course', 'teacher'];
    this.applyFilter(filter);

    // if (loadOnInit) this.load();
    window.addEventListener('scroll', e => this.onScroll(e));
    this.onScroll();
  }

  initFilter() {
    const countElem = this.elem.querySelector('[data-feedback-count]');

    this.elem.addEventListener('feedbackChange', function(event) {
      countElem.hidden = false;

      countElem.children[0].innerHTML = event.detail.loader.total;
      countElem.children[1].innerHTML = pluralize(event.detail.loader.total, t('courses.group_feedback_list.plural_feedback'));
    });

    this.selects = this.form.elements;

    for (let select of this.selects) {
      select.addEventListener('change', () => {
        this.filter[select.name] = select.value;
        this.applyFilter(this.filter);
      })
    }
  }

  onScroll() {
    if (!this.hasMore) return;

    if (this.container.getBoundingClientRect().bottom <= document.documentElement.clientHeight && !this.isLoading) {
      this.load(true);
    }
  }

  applyFilter(filter) {
    this.filter = {...this.defaults, ...filter};

    for (let item in this.filter) {
      if (this.selects && this.selects[item]) this.selects[item].querySelector(`option[value='${this.filter[item]}']`).selected = true;
    }
    // we don't touch predefined values if they are not in activeFilter param
    for (let param of this.activeFilters) {
      if (this.selects && this.selects[param] && !this.filter[param]) this.selects[param].querySelector('option:first-child').selected = true;
    }

    // reset
    this.count = 0;
    this.total = null;
    this.hasMore = true;

    this.load();
  }

  load(append = false) {
    let url = `${this.baseUrl}?skip=${this.count}&needTotal=${this.total === null ? 1 : 0}`;

    for (let key in this.filter) {
      url += `&${key}=${this.filter[key]}`;
    }

    const request = xhr({
      method: 'GET',
      json:   true,
      url:    url
    });

    this.elem.classList.add('course-feedbacks_loading');

    this.isLoading = true;

    request.addEventListener('loadend', () => {
      this.isLoading = false;
      this.elem.classList.remove('course-feedbacks_loading');
    });

    request.addEventListener('success', (event) => {
      if (event.result.total !== undefined) {
        this.total = event.result.total;
      }

      if (event.result.count) {
        if (append) this.container.insertAdjacentHTML('beforeend', event.result.html);
        else this.container.innerHTML = event.result.html;
        this.count += event.result.count;
      } else if (!this.count) {
        // if multiple load calls hit it => no multi-append
        this.container.innerHTML = `<p>${t('courses.feedback_loader.no_feedback')}</p>`;
        this.elem.classList.add('course-feedbacks_no-feedback');
      }

      if (event.result.hasMore === false) {
        this.hasMore = false;
      }

      this.elem.dispatchEvent(new CustomEvent('feedbackChange', {
        bubbles: true,
        detail: {
          loader: this
        }
      }));
    });
  }
}

module.exports = FeedbackLoader;
